import { ROLES } from "../common/Const";

export const MANAGEMENT_ROLES = [ROLES.ADMIN, ROLES.OPERATOR, ROLES.TEACHER];

const getActiveRole = principal => (typeof principal === "string" ? principal : principal && principal.role);
const getSystemRoles = principal => (
  principal && Array.isArray(principal.systemRoles) ? principal.systemRoles : []
);
const hasAnyRole = (principal, roles) => (
  roles.includes(getActiveRole(principal)) ||
  getSystemRoles(principal).some(role => roles.includes(role))
);

export const getEffectivePermissionRole = (principal) => {
  if (hasAnyRole(principal, [ROLES.ADMIN])) return ROLES.ADMIN;
  if (hasAnyRole(principal, [ROLES.OPERATOR])) return ROLES.OPERATOR;
  return getActiveRole(principal);
};

export const isManageRole = principal => (
  MANAGEMENT_ROLES.includes(getActiveRole(principal)) ||
  hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR])
);
export const isTeacher = principal => getActiveRole(principal) === ROLES.TEACHER;
export const canReadClients = principal => isManageRole(principal);
export const canReadTeachers = principal => isManageRole(principal);
export const canReadBooks = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canReadPayments = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageClasses = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageClassStudents = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManageSettings = principal => hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
export const canManagePermissions = principal => hasAnyRole(principal, [ROLES.ADMIN]);

export function canAccessManagePath(principal, pathname) {
  if (!isManageRole(principal)) return false;
  if (pathname.startsWith("/manage/payment-reminders")) return canReadPayments(principal) && canReadClients(principal);
  if (pathname.startsWith("/manage/permissions")) return canManagePermissions(principal);
  if (pathname.startsWith("/manage/settings")) return canManageSettings(principal);
  if (pathname.startsWith("/manage/people")) return true;
  if (/^\/manage\/(client|student|teacher)\/new\/?$/.test(pathname)) return hasAnyRole(principal, [ROLES.ADMIN, ROLES.OPERATOR]);
  if (/^\/manage\/client\/[^/]+\/(ledger|notifications)/.test(pathname)) return canReadPayments(principal);
  if (pathname.startsWith("/manage/clients") || pathname.startsWith("/manage/client/")) return canReadClients(principal);
  if (pathname.startsWith("/manage/books") || pathname.startsWith("/manage/book/")) return canReadBooks(principal);
  if (pathname.startsWith("/manage/products") || pathname.startsWith("/manage/product/")) return canReadPayments(principal);
  if (pathname.startsWith("/manage/enrollments") || pathname.startsWith("/manage/enrollment/")) return canReadPayments(principal);
  if (pathname.startsWith("/manage/teachers") || pathname.startsWith("/manage/teacher/")) return canReadTeachers(principal);
  if (pathname.startsWith("/manage/student/")) return true;
  if (pathname.startsWith("/manage/reports/client-settlements")) return canReadPayments(principal);
  return true;
}
